import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  LOCALE_ID
} from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { NowGlobals } from '@now/dpl';
import { provideErrorInterceptor } from '../../../suche-lib/src/lib/interceptors/error/error.interceptor';
import { LIB_CONFIG, LibConfig, Loglevel } from '../../../suche-lib/src/lib/lib.config';
import { provideNowErrorHandler } from '../../../suche-lib/src/lib/services/integration/error.handler';
import { SucheLibModule } from '../../../suche-lib/src/lib/suche-lib.module';
import { APP_ROUTES } from './app.routes';
import { OpenGraphService } from './service/open-graph.service';
import { OiamConfig } from '../../../suche-lib/src/lib/services/oiam/oiam.service';
import { OPEN_GRAPH_SERVICE } from '../../../suche-lib/src/lib/services/open-graph.service';

/**
 * Definiert die Typen der suchConfig und oiamConfig auf dem window Objekt
 */
declare global {
  interface Window {
    sucheConfig: {
      backendHost: string;
      entgeltatlasHost: string;
      sucheMitBildungszielen: boolean;
      ladeanimation: 'true' | 'false';
      ortsunabhaengig: 'true' | 'false';
      showThemenfelder: 'true' | 'false';
      showHeader: 'true' | 'false';
      showFeedbackComponent: 'true' | 'false';
      showBefragungBanner: 'true' | 'false';
      geoisGeocodeServer: string;
      geoisStylesheetUrl: string;
      geoisScriptUrl: string;
      geoisImageServer: string;
      nowPortalBasePath: string;
      baBasePath: string;
      newPlanBasePath: string;
      logLevel: Loglevel;
      isNowWbSuche: boolean;
    };
    oiamConfig: OiamConfig;
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule, SucheLibModule),
    provideRouter(APP_ROUTES),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    provideErrorInterceptor(),
    { provide: Meta },
    {
      provide: OPEN_GRAPH_SERVICE,
      useClass: OpenGraphService
    },
    {
      provide: APP_INITIALIZER,
      useValue: () => {
        NowGlobals.init();
        window.dpl?.global?.init();
      },
      multi: true
    },
    {
      provide: LIB_CONFIG,
      useFactory: () =>
        ({
          backendHost: window.sucheConfig.backendHost,
          entgeltatlasHost: window.sucheConfig.entgeltatlasHost,
          sucheMitBildungszielen: window.sucheConfig?.sucheMitBildungszielen ?? false,
          showLadeanimation: window.sucheConfig?.ladeanimation === 'true',
          showOrtsunabhaengig: window.sucheConfig?.ortsunabhaengig !== 'false',
          showThemenfelder: window.sucheConfig?.showThemenfelder === 'true',
          showHeader: window.sucheConfig?.showHeader === 'true',
          showFeedbackComponent: window.sucheConfig?.showFeedbackComponent === 'true',
          showBefragungBanner: window.sucheConfig?.showBefragungBanner === 'true',
          nowPortalBasePath: window.sucheConfig?.nowPortalBasePath,
          baBasePath: window.sucheConfig?.baBasePath,
          newPlanBasePath: window.sucheConfig?.newPlanBasePath,
          isNowWbSuche: window.sucheConfig?.isNowWbSuche,
          logLevel: window.sucheConfig?.logLevel,
          geois: {
            geoisGeocodeServer: window.sucheConfig.geoisGeocodeServer,
            geoisStylesheetUrl: window.sucheConfig.geoisStylesheetUrl,
            geoisScriptUrl: window.sucheConfig.geoisScriptUrl,
            geoisImageServer: window.sucheConfig.geoisImageServer
          },
          oiam: {
            clientId: window.oiamConfig.clientId,
            logouturi: window.oiamConfig.logouturi,
            oiamOauthWcUrl: window.oiamConfig.oiamOauthWcUrl,
            redirecturi: window.oiamConfig.redirecturi,
            metadataUrl: window.oiamConfig.metadataUrl
          }
        }) as LibConfig
    },
    provideNowErrorHandler(),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations()
  ]
};
